package com.upcominds.expedite.di

import com.upcominds.expedite.data.auth.AuthConfigProvider
import com.upcominds.expedite.data.auth.JsTokenStorage
import com.upcominds.expedite.data.auth.OidcAuthPlatform
import com.upcominds.expedite.data.auth.OidcAuthPlatformImpl
import com.upcominds.expedite.data.auth.TokenStorage
import com.upcominds.expedite.data.documents.DocumentPicker
import com.upcominds.expedite.data.documents.JsDocumentPicker
import org.koin.core.module.Module
import org.koin.dsl.module

fun platformModule(): Module = module {
    single<TokenStorage> { JsTokenStorage() }
    single<OidcAuthPlatform> { OidcAuthPlatformImpl(AuthConfigProvider.oidcConfig) }
    single<DocumentPicker> { JsDocumentPicker() }
}
